import { brl, MODULE_LABELS } from "@/lib/api";

export function MonthlyBreakdown({ plan, extras }) {
  if (!plan) return null;
  const extra = extras.reduce((s, i) => s + i.price, 0);
  return (
    <div className="card-surface space-y-2 p-5 text-sm" data-testid="monthly-breakdown">
      <p className="eyebrow">Sua mensalidade · plano {plan.name}</p>
      <div className="flex justify-between"><span>Plano {plan.name}</span><span className="font-mono">{brl(plan.price)}</span></div>
      {extras.map((i) => (
        <div key={i.module} className="flex justify-between text-muted-foreground" data-testid={`breakdown-${i.module}`}>
          <span>+ Módulo {MODULE_LABELS[i.module] || i.module}</span><span className="font-mono">{brl(i.price)}</span>
        </div>
      ))}
      {!extras.length && <p className="text-xs text-muted-foreground">Sem módulos extras na sua conta.</p>}
      <div className="flex justify-between border-t pt-2 font-semibold"><span>Total por mês</span><span className="font-mono" data-testid="breakdown-total">{brl(plan.price + extra)}</span></div>
      <p className="text-xs text-muted-foreground">Nos períodos trimestral e anual, o desconto vale também para os módulos extras.</p>
    </div>
  );
}
